// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchMobile_toolbar__6cAG2 {\n  height: 80px;\n}\n.SearchMobile_checkbox__2D4Bl {\n  right: 6px;\n  position: absolute;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Search/SearchMobile.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".toolbar {\n  height: 80px;\n}\n.checkbox {\n  right: 6px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": "SearchMobile_toolbar__6cAG2",
	"checkbox": "SearchMobile_checkbox__2D4Bl"
};
export default ___CSS_LOADER_EXPORT___;
